import { NgModule } from '@angular/core';
import { MathExpressionModule } from '@games/maths/shared/components/math-expression/math-expression.module';
import { MathResultContainerComponent } from '@games/maths/shared/components/math-result-container/math-result-container.component';
import { GamesSharedModule } from './games-shared.module';

@NgModule({
  imports: [GamesSharedModule, MathExpressionModule, MathResultContainerComponent],
  exports: [GamesSharedModule, MathExpressionModule, MathResultContainerComponent],
})
export class MathGamesSharedModule {}
